import {
  CameraList,
  CameraListResponse,
  PrinterInfo,
  PrinterInfoCreateParams,
  PrinterInfoResponse,
  PrinterList,
  PrinterListCreateParams,
  PrinterListResponse,
} from '@apiContract';

import { receivedDigitalApi } from './index';

type CameraListParams = {
  rdConnectInstanceId?: number;
};

const connectOperationsApi = receivedDigitalApi.injectEndpoints({
  endpoints: (builder) => ({
    getCamerasList: builder.query<CameraList, CameraListParams>({
      query: (requestData) => ({
        url: `RdConnectOperations/camera-list/${requestData.rdConnectInstanceId}`,
        params: requestData,
      }),
      transformResponse: (response: CameraListResponse): CameraList => response.objectData,
    }),
    getPrinterList: builder.query<PrinterList, PrinterListCreateParams>({
      query: ({ connectionId }) => `RdConnectOperations/printer-list/${connectionId}`,
      transformResponse: (response: PrinterListResponse): PrinterList => response.objectData,
    }),
    checkPrinterStatus: builder.query<PrinterInfo, PrinterInfoCreateParams>({
      query: (params) => `RdConnectOperations/printer-info/${params.connectionId}/${params.name}`,
      transformResponse: (response: PrinterInfoResponse): PrinterInfo => response.objectData,
    }),
  }),
});

export const { useGetCamerasListQuery, useGetPrinterListQuery, useCheckPrinterStatusQuery } = connectOperationsApi;
